// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"692":"eec6443e","884":"d1428304"}[chunkId] + ".chunk.js";
};